import Serializable from "@/core/misc/mixins/Serializable";
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES       from "@/core/services/Changelogs/types";

class Address extends Serializable {
	@Title_ru_RU('Адрес склада', TYPES.STRING)
	public stringRepresentation: string;

	@Title_ru_RU('Город', TYPES.STRING)
	public cityName: string;

	@Title_ru_RU('Код страны', TYPES.STRING)
	public countryCode: string;

	toString(): string {
		return this.stringRepresentation ?? '';
	}

	static fromServer(data: any, result = new Address()): Address {
		super.fromServer(data, result);
		return result;
	}
}

export default Address;
